import BaseModel from "./BaseModel";
import {action, makeObservable, observable, reaction} from "mobx";
import {post} from '../common/requester'
import Tournament from "./Tournament";


export default class Trainer extends BaseModel {
    constructor(store) {
        super(store);
        makeObservable(this, {
            company_id: observable,
            team: observable,
            team_id: observable,
            getClasses: action,
            classesLoading: observable,
            setLoading: action,
            class: observable,
            classLoading: observable,
            setClassLoading: action,
            getClass: action,
            toggleParticipation: action,
            sendClassPhotos: action,
            members: observable,
            getMembers: observable,
            contest: observable
        })
        
        reaction(()=>this.company_id, (new_id, old_id) => {
          this.contest.setProperty('company_id', new_id)
        })
    }
    
    classesLoading = false
    company_id = 0
    team = {}
    team_id = 0
    class = {}
    classLoading = false
    members = []
    contest = new Tournament(this, 'trainer')
    
    setLoading(loading) {
        this.classesLoading = loading
    }
    
    setClassLoading(loading) {
        this.classLoading = loading
    }
    
    async getClasses() {
        if (this.classesLoading) return Promise.resolve()
        if (!this.team_id) return Promise.resolve()
        this.setLoading(true)
        const ret = await post('trainer/last_classes', {
            company_id: this.company_id,
            team_id: this.team_id
        }).catch((err) => console.error('--last classes error', err))
          .finally(() => this.setLoading(false))
        if (ret && ret.result === 0) {
            this.setProperty('team', ret.classes)
        }
    }
    
    async getClass(team_id, date) {
        if (this.classLoading) return Promise.resolve()
        this.setClassLoading(true)
        const ret = await post('trainer/class/edit', {
            team_id: team_id,
            class_date: date
        }).catch((err) => console.error('--class edit error', err))
          .finally(() => this.setClassLoading(false))
        if (ret && ret.result === 0) {
            this.setProperty('class', ret.class)
        }
    }
    async toggleParticipation(class_id, company_user_id) {
        await post('trainer/class/participation', {
            tc_id: class_id,
            cu_id: company_user_id
        }).catch((err) => console.error('--toggle participation error', err))
    }
    
    async sendClassPhotos(team_id, class_date, is_album=false) {
        await post('trainer/send_class_photos', {
            company_id: this.company_id,
            team_id: team_id,
            class_date: class_date,
            is_album: is_album
        }).catch(error => console.log(error))
    }
    
    async getMembers() {
        if (!this.team_id) return Promise.resolve()
        const ret = await post('trainer/members', {
            company_id: this.company_id,
            team_id: this.team_id
        }).catch((err) => console.error('--members error', err))
        
        if (ret && ret.result === 0) {
            this.setProperty('members', ret.members)
        }
    }

    async getTournaments() {
        const ret = await post('game/get_tournaments', {
            company_id: this.company_id,
            team_id: this.team_id
        }).catch((err) => console.error('--members error', err))

        if (ret && ret.result === 0) {
            this.setProperty('members', ret.members)
        }
    }
}